<template>
	<div class="group">
		<input :id="identifier" :name="identifier" type="checkbox" @change="$emit('input', $event.target.checked); $emit('valueChanged');" :checked="value" v-bind="attrs">
		<label v-if="label" :for="identifier" :style="{ width: labelWidth + 'px' }">{{label}}</label>
	</div>
</template>

<script>
	export default {
		name: 'TextInput',
		props: ['label', 'value', 'identifier', 'labelWidth', 'attrs']
	}
</script>

<style lang="scss" scoped>
	input{
		width: 15px;
		height: 15px;
		float:left;
	}

	label {
		margin-top: -1px;
		margin-left: 10px;
		display: block;
		float: left;
	}
</style>
